module.exports = __webpack_public_path__ + "static/media/stage-iii-kit-softail-zoom.7f4228ab.png";